<template>
  <div class="printingsurface-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('printingsurface_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('printingsurface.printingsurfaces')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <PrintingSurfaceFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import PrintingSurfaceFilterForm from '../../components/printingsurface/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'PrintingSurfaceList',
  servicePrefix: 'PrintingSurface',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    PrintingSurfaceFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
      ],
  selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('printingsurface', {
      items: 'list'
    }),
    ...mapFields('printingsurface', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('printingsurface', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
